import { memo } from 'react';

import { preserveTrailingLineBreaks, sanitizeRichTextHtml } from '@/shared/utils/sanitize-html';

import { cn } from '@/utils/styles';

type RichTextContentProps = {
	html: string;
	className?: string;
};

/**
 * Static, server-renderable display of TipTap-authored HTML. Unlike the
 * read-only RichTextEditor (immediatelyRender: false, client-only), this
 * puts the content in the SSR HTML so crawlers can read it.
 */
function RichTextContent({ html, className }: RichTextContentProps) {
	const sanitizedHtml = preserveTrailingLineBreaks(sanitizeRichTextHtml(html));

	if (!sanitizedHtml) return null;

	return (
		<div
			className={cn(
				'tiptap ProseMirror word-break w-full bg-transparent text-base leading-normal text-primary',
				className
			)}
			dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
		/>
	);
}

export default memo(RichTextContent);
